import React from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'ja', label: 'JP' },
  { code: 'en', label: 'EN' },
  { code: 'pt', label: 'PT' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language;

  function handleChange(code: string) {
    i18n.changeLanguage(code);
    localStorage.setItem('bjjcore-lang', code);
  }

  return (
    <div className="flex items-center gap-1">
      {languages.map(({ code, label }, idx) => (
        <React.Fragment key={code}>
          <button
            onClick={() => handleChange(code)}
            className={`text-xs font-medium px-1 transition-colors duration-150 ${
              current === code
                ? 'text-primary font-bold'
                : 'text-slate-400 hover:text-slate-700'
            }`}
            aria-label={`Switch to ${label}`}
          >
            {label}
          </button>
          {idx < languages.length - 1 && (
            <span className="text-slate-300 text-xs select-none">|</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
